import React, {useEffect, useState} from "react";
import ReportTemplateService from "../../../services/ReportTemplate/reportTemplate.service";
import { ReportTemplate } from "../../../models/ReportTemplate/reportTemplate.model";
import "./manageTemplates.scss";
import { Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

interface ManageTemplateProps {
  editorValue: string;
  setReportTemplateName: (value: string) => void;
  setEditorValue: (value: string) => void;
  activeManageTemplateId?: number;
  setActiveManageTemplateId: (templateId?: number) => void;
  refreshReportTemplates?: boolean;
}

export default function ManageTemplates({
  editorValue, 
  setReportTemplateName, 
  setEditorValue, 
  activeManageTemplateId, 
  setActiveManageTemplateId,
  refreshReportTemplates,
}: ManageTemplateProps) {
  const [reportTemplates, setReportTemplates] = useState<ReportTemplate[]>([]);

  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  // filter templates by name (case-insensitive)
  const filteredTemplates = reportTemplates?.filter((template) =>
      template.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const fetchReportTemplates = (searchText: string) => {
    setLoading(true);
    ReportTemplateService.fetchReportTemplates(
      searchText,
      0,
      (reportTemplates: ReportTemplate[]) => {
        setReportTemplates(reportTemplates);
      },
      () => {},
      () => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if(activeManageTemplateId && reportTemplates?.length > 0) {
      const selectedTemplate = reportTemplates.find((template) => template.id === activeManageTemplateId);
      setEditorValue(selectedTemplate?.content ?? '');
      setReportTemplateName(selectedTemplate?.name ?? '');
    }
  }, [activeManageTemplateId, reportTemplates, setEditorValue, setReportTemplateName]);
  
  useEffect(() => {
    fetchReportTemplates("");
  }, []);

  useEffect(() => {
    if(refreshReportTemplates) {
      fetchReportTemplates(searchTerm);
    }
  }, [refreshReportTemplates, searchTerm])

  return <div className="manage-templates">
    <div className="manage-templates__add-template-wrapper">
      <Button type="primary" className="add-template-btn" onClick={() => {
        setActiveManageTemplateId(undefined);
        setEditorValue('');
        setReportTemplateName('');
      }}>Add New Template</Button>
    </div>
    <div className="manage-templates__seach-wrapper">
      <Input 
        prefix={<SearchOutlined/>}
        placeholder="Search templates"
        className="manage-templates__search-input"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        allowClear
      />
    </div>
    <div className="manage-template__template-list">
      {filteredTemplates?.map((template) => (
          <div
            key={template.id}
            className={`manage-template__template-item ${
                template?.id === activeManageTemplateId ? "active" : ""
            }`}
            onClick={() => setActiveManageTemplateId(template.id)}
          >
            {template.name}
          </div>
      ))}

      {filteredTemplates?.length === 0 && (
          <div className="no-results">No templates found</div>
      )}
    </div>
  </div>;
};